import React, { useEffect, useCallback } from 'react'
import { RootState, Dispatcher } from 'AppTypes'
import { connect } from 'react-redux'
import { Spinner } from 'react-bootstrap'
import * as actions from '../state_management/actions'

const mapStateToProps = (state: RootState) => ({
  isLoading: state.store.isLoading,
  hasNextPage: state.store.hasNextPage,
  videoGoLiver: state.store.videoGoLiver,
  videos: state.store.videos,
  page: state.store.page
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  fetchVideoGoLiver: (params: any) => dispatch(actions.fetchVideoGoLiver(params)),
  setIsLoading: (isLoading: boolean) => dispatch(actions.setLoading(isLoading)),
  setPage: (page: number) => dispatch(actions.setPage(page))
})

const limit = 9

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & ReturnType<any>

const ListVideoGoLiver: React.FC<Props> = ({
  fetchVideoGoLiver,
  setIsLoading,
  isLoading,
  hasNextPage,
  setPage,
  page,
  id,
  videos,
  onSelectVideo
}) => {
  const fetchVideo = useCallback(async (params: {}) => {
    await fetchVideoGoLiver(params)
  }, [fetchVideoGoLiver])
  const onLoadMoreVideo = () => {
    setPage(page + 1)
  }
  useEffect(() => {
    setIsLoading(true)
    fetchVideo({ StoreId: id, PageIndex: page, PageSize: limit })
    setIsLoading(false)
  }, [page, fetchVideo, id, setIsLoading])

  return (
    <>
      <div className="video-list">
        {
          videos && videos.map((video : any) => (
            <div key={video.id} className="video-items" data-content={video.title} role="presentation" onClick={() => onSelectVideo(video)}>
              <i className="bi bi-play-circle-fill play-icon" />
              {video.imageThumbnail
                ? <img src={video.imageThumbnail} alt={video.title} />
                : (
                  <video height="100%" width="100%">
                    <source src={video.videoUrl} type="video/mp4" />
                    <track kind="captions" />
                    Your browser does not support HTML video.
                  </video>
                )}
            </div>
          ))
        }
      </div>
      <div className="more-video w-100 text-center mt-3">
        {hasNextPage
          && (
            <a href="#" onClick={onLoadMoreVideo}><i className="bi bi-chevron-down" />もっと見る</a>
          )}
      </div>
      {isLoading && <Spinner animation="border" />}
    </>

  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListVideoGoLiver)
